export const SET_AUTH = "setAuth";
export const PURGE_AUTH = "purgeAuth";
export const SET_NOTIFICATION = "setNotification";
export const SET_LOADING = "setLoading";

export const SET_TOKEN = "setToken";
export const SET_PAGE_HEADER = "setPageHeader";

export const SET_CONNECTED_WS = "setConnectedWs";

export const SET_IS_ONLINE = "setIsOnline";

export const SET_STC = "setStc";
